module.exports = __webpack_public_path__ + "static/media/short-of-breath-white.ba8b0aab.svg";